import { createContext } from 'react';
import { ConfiguratorResultData } from '../../types';

export const ConfiguratorDataContext = createContext<{ data?: ConfiguratorResultData }>({});
